import React, { CSSProperties, FC, ReactNode } from 'react';
import ModalOverlay from 'components/Modals/ModalOverlay1';
import { FiX } from 'react-icons/fi';
import cn from 'classnames';
import css from './styles.module.scss';
import Card from '../Card';
import LoaderWrapper from '../Loader/LoaderWrapper';

interface IBaseModalProsp {
  onClose: () => void;
  isOpen: boolean;
  isLoading?: boolean;
  actions?: ReactNode;
  title?: string | ReactNode;
  customWidth?: number;
  style?: CSSProperties;
  className?: string;
  /** Для второго окна рядом */
  additionalModal?: ReactNode | null;
  /** Разрешает ли закрывать при клике вне модалки */
  clickOutside?: boolean;
}

const BaseModal: FC<IBaseModalProsp> = ({
  onClose,
  isOpen,
  isLoading,
  children,
  actions,
  title,
  customWidth,
  style,
  className,
  additionalModal,
  clickOutside = false,
}) => (
  <ModalOverlay
    onCloseModal={onClose}
    isOpen={isOpen}
    className={cn('BaseModal_component', className)}
    clickOutside={clickOutside}
  >
    <div
      className={cn(css.card_wrapper, {
        _hasTwoModal: additionalModal,
      })}
    >
      <Card
        className={css.card}
        noHover
        style={{ maxWidth: `${customWidth}px`, ...style }}
      >
        <div
          className={cn(css.card_header, {
            isNoTitle: !title,
          })}
        >
          {title && <div className={css.card_title}>{title}</div>}
          <div className={css.card_close} onClick={onClose}>
            <FiX size={24} />
          </div>
        </div>
        {!isLoading ? (
          <div className={css.card_form}>
            <div className={css.card_child}>{children}</div>
            {actions && <div className={css.card_actions}>{actions}</div>}
          </div>
        ) : (
          <LoaderWrapper />
        )}
      </Card>
      {additionalModal && (
        <Card
          className={css.card}
          noHover
          style={{ maxWidth: `${customWidth}px`, ...style }}
        >
          {additionalModal}
        </Card>
      )}
    </div>
  </ModalOverlay>
);

export default BaseModal;
